"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = filterWhitespaceNodes;

var _walk = _interopRequireDefault(require("./walk"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isAllWhitespace = function isAllWhitespace(node) {
  var isTextNode = node.nodeType === Node.TEXT_NODE;
  var isWhitespace = !/[^\t\n\r ]/.test(node.textContent);
  return isTextNode && isWhitespace;
};
/**
 * `filterWhitespaceNodes` will remove any whitespace markup contained within the passed `Node`
 *
 * @param rootDOMNode the domNode
 */


function filterWhitespaceNodes(domNode) {
  return (0, _walk["default"])(domNode, function (node) {
    if (isAllWhitespace(node)) {
      node.parentNode.removeChild(node);
    }
  });
}